<template>
  <div>
    <!-- <span>我的订单页面</span> -->
    <el-table
      border
      :data="dataArray"
      style="width: 100%"
      :header-cell-style="headerStyle"
    >
      <el-table-column prop="productName" label="产品名称"></el-table-column>
      <el-table-column prop="productId" label="产品ID"></el-table-column>
      <el-table-column prop="price" label="订单金额(元)"> </el-table-column>
      <el-table-column prop="orderTime" label="订购时间"> </el-table-column>
      <el-table-column
        prop="resultCode"
        :formatter="formatResultCode"
        label="订购结果"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from "axios";
import md5 from "js-md5";

function getCurTime() {
  let nowDate = new Date();
  let date = {
    year: nowDate.getFullYear(),
    month: nowDate.getMonth() + 1,
    date: nowDate.getDate(),
    hours: nowDate.getHours(),
    minutes: nowDate.getMinutes(),
    seconds: nowDate.getSeconds()
  };
  let newmonth = date.month > 10 ? date.month : "0" + date.month;
  let newday = date.date > 10 ? date.date : "0" + date.date;
  let newminutes = date.minutes < 10 ? "0" + date.minutes : date.minutes;
  let newseconds = date.seconds < 10 ? "0" + date.seconds : date.seconds;

  let newTime =
    date.year + newmonth + newday + date.hours + newminutes + newseconds;
  return newTime;
}

const request = axios.create({
  baseURL: "http://120.76.216.37:9083",
  timeout: 10000 //超时时间
});

request.interceptors.request.use(
  function(config) {
    let appSecret = "fsdljj9pnjnkfasdfjdgsaj";

    config.headers.channelCode = "mayidui";
    config.headers.timestamp = getCurTime();
    config.headers.sign = md5(
      config.headers.timestamp + config.headers.channelCode + appSecret
    );
    config.headers.version = "V1.0";
    console.log("config==" + config);
    return config;
  },
  function(erro) {
    return Promise.reject(erro);
  }
);

export default {
  data() {
    return {
      token: "",
      dataArray: ""
    };
  },
  mounted() {
    this.token = this.$route.query.token;
    console.log("获取到的token参数为:" + this.token);

    request
      .get("productMarket/queryHistoryOrder", {
        params: {
          //body参数
          token: this.token
        }
      })
      .then(value => {
        console.log("订单信息：" + value);
        let resCode = value.data.code;
        if (resCode == 0) {
          console.log("订单信息：resCode == 0");
          //订单信息
          this.dataArray = value.data.dataArray;
        } else if (resCode == 9) {
          console.log("订单信息：resCode == 9");
          //token值失效
          this.$store.commit("$_removeStorage");
          this.$store.commit("$_removeStorage2");
          alert("用户登录信息已过期，请重新登录!");
        }
      })
      .catch(reason => {
        console.log(reason);
        alert("网络请求失败，请重试!");
      });
  },
  methods: {
    formatResultCode: function(row, column) {
      console.log("row.resultCode==" + row.resultCode);
      if (row.resultCode == 0) {
        return "处理中";
      } else if (row.resultCode == 1) {
        return "订单成功";
      } else if (row.resultCode == 2) {
        return "订单失败";
      }
    },
    headerStyle() {
      return {
        // background: "#043B79",
        // padding: "5px 0",
        // borderColor: "#006CC1",
        // textAlign: "center",
        color: "#bf7500", //rgb(191, 117, 0),
        fontSize: "14px"
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/myOrder.vue